import { combineReducers } from 'redux';
import { CACHE_ACTIONS } from '~/constants/cache-actions.constants';
import { LocalCacheHandler } from '~/utils/local-cache-handler';
import * as ACTIONS from './actions';
import moment from 'moment';

import columnsReducer from './reducers/columnsReducer';
import drawerReducer from './components/Drawer/reducer';
import metricsReducer from './reducers/metricsReducer';
import { BASE_COLUMNS } from './constants';
import * as DRAWER_ACTIONS from './components/Drawer/actions';

// Inline loadingReducer
const isLoading = (state = true, action) => {
  switch (action.type) {
    case ACTIONS.LOAD_LEADS.SUCCESS:
      return false;
    case ACTIONS.LOAD_LEADS.INIT:
      return true;
    default:
      return state;
  }
};

// Hide leads reducer
const hideLeads = (state = false, action) => {
  switch (action.type) {
    case CACHE_ACTIONS.leads:
      return action.payload.hideLeads || false;
    case ACTIONS.LOAD_LEADS.SUCCESS:
      return action.payload.data.hideLeads || false;
    default:
      return state;
  }
};

const leadsReducer = combineReducers({
  columns: columnsReducer,
  drawer: drawerReducer,
  metrics: metricsReducer,
  isLoading,
  hideLeads,
  selectedDate: (state, action) => {
    // Default state for selectedDate
    const defaultState = moment().format("MM-YYYY");
    
    // Ensure we have a valid state
    const currentState = state !== undefined ? state : defaultState;
    
    try {
      switch (action.type) {
        case ACTIONS.SET_DATE:
          return action.payload.date;
        default:
          return currentState;
      }
    } catch (error) {
      console.error('Error in selectedDate reducer:', error);
      return defaultState;
    }
  },
});

const reducer = (state, action) => {
  // Ensure we have a default state
  const defaultState = {
    columns: BASE_COLUMNS,
    drawer: { data: { id: null }, show: false },
    metrics: { currentMetrics: null, currentSummary: {} },
    isLoading: true,
    hideLeads: false,
    selectedDate: moment().format("MM-YYYY")
  };
  
  const currentState = state || defaultState;
  
  if (action.type === CACHE_ACTIONS.leads) {
    // Merge cached data with base columns structure
    const mergedColumns = BASE_COLUMNS.map(baseColumn => {
      const cachedColumn = (action.payload.columns || []).find(col => col.id === baseColumn.id);
      return {
        ...baseColumn,
        leads: cachedColumn && cachedColumn.leads || [],
        total: cachedColumn && cachedColumn.total || 0,
        selectedMonth: cachedColumn && cachedColumn.selectedMonth || 0
      };
    });
    
    return {
      ...currentState,
      columns: mergedColumns,
      hideLeads: action.payload.hideLeads || false,
      metrics: {
        currentMetrics: action.payload.metaInfo && action.payload.metaInfo.metrics || null,
        currentSummary: action.payload.metaInfo && action.payload.metaInfo.summary || {}
      }
    };
  }

  const newState = leadsReducer(currentState, action);
  
  // Update cache for relevant actions
  const updateCache = [
    ACTIONS.LOAD_LEADS.SUCCESS,
    ACTIONS.MOVE.SUCCESS,
    ACTIONS.LOAD_MORE_LEADS.SUCCESS,
    ACTIONS.FETCHQTDD.SUCCESS,
    ACTIONS.SAVE_METRICS.SUCCESS,
    DRAWER_ACTIONS.SAVE.SUCCESS,
    DRAWER_ACTIONS.CREATE.SUCCESS,
    DRAWER_ACTIONS.DELETE.SUCCESS
  ].includes(action.type);

  if (updateCache) {
    LocalCacheHandler.save({
      pathname: CACHE_ACTIONS.leads,
      data: newState
    });
  }

  return newState;
};

export default reducer;
